/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { InventoryMasterModel } from '../model/inventoryMasterModel';
import { SmartDineResponseInventoryMasterModel } from '../model/smartDineResponseInventoryMasterModel';
import { SmartDineResponseListInventoryMasterModel } from '../model/smartDineResponseListInventoryMasterModel';
import { SortByParam } from '../model/sortByParam';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class InventoryMasterControllerService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  private getHeaders(consumes: string[] = ['application/json']): HttpHeaders {
    let headers = this.defaultHeaders;
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept([
      '*/*',
    ]);
    if (httpHeaderAcceptSelected) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }
    const httpContentTypeSelected =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }
    return headers;
  }

  private buildQueryParams(params: Record<string, any>): HttpParams {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    for (const key in params) {
      if (params[key] !== undefined && params[key] !== null) {
        queryParameters = queryParameters.set(key, params[key]);
      }
    }
    return queryParameters;
  }

  private request<T>(
    method: string,
    url: string,
    body?: any,
    queryParams?: HttpParams,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    const headers = this.getHeaders();
    return this.httpClient.request<T>(method, `${this.basePath}${url}`, {
      body: body,
      params: queryParams,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  public createInventoryMaster(
    body: InventoryMasterModel,
    restaurantId: string,
    restaurantBranchId: string,
    observe?: 'body' | 'response' | 'events',
    reportProgress?: boolean
  ): Observable<any> {
    if (!body || !restaurantId || !restaurantBranchId) {
      throw new Error(
        'Required parameter missing when calling createInventoryMaster.'
      );
    }
    const queryParams = this.buildQueryParams({
      restaurantId,
      restaurantBranchId,
    });
    return this.request<SmartDineResponseInventoryMasterModel>(
      'post',
      '/api/admin/inventorymasters',
      body,
      queryParams,
      observe,
      reportProgress
    );
  }

  public deleteInventoryMaster(
    restaurantId: string,
    restaurantBranchId: string,
    inventoryMasterId: string,
    observe?: 'body' | 'response' | 'events',
    reportProgress?: boolean
  ): Observable<any> {
    if (!restaurantId || !restaurantBranchId || !inventoryMasterId) {
      throw new Error(
        'Required parameter missing when calling deleteInventoryMaster.'
      );
    }
    const queryParams = this.buildQueryParams({
      restaurantId,
      restaurantBranchId,
    });
    return this.request<SmartDineResponseInventoryMasterModel>(
      'delete',
      `/api/admin/inventorymasters/${encodeURIComponent(
        String(inventoryMasterId)
      )}`,
      null,
      queryParams,
      observe,
      reportProgress
    );
  }

  public getInventoryMaster(
    restaurantId: string,
    restaurantBranchId: string,
    inventoryMasterId: string,
    observe?: 'body' | 'response' | 'events',
    reportProgress?: boolean
  ): Observable<any> {
    if (!restaurantId || !restaurantBranchId || !inventoryMasterId) {
      throw new Error(
        'Required parameter missing when calling getInventoryMaster.'
      );
    }
    const queryParams = this.buildQueryParams({
      restaurantId,
      restaurantBranchId,
    });
    return this.request<SmartDineResponseInventoryMasterModel>(
      'get',
      `/api/admin/inventorymasters/${encodeURIComponent(
        String(inventoryMasterId)
      )}`,
      null,
      queryParams,
      observe,
      reportProgress
    );
  }

  public getInventoryMasters(
    restaurantId: string,
    restaurantBranchId: string,
    pageNo?: number,
    pageSize?: number,
    sortByParams?: Array<SortByParam>,
    observe?: 'body' | 'response' | 'events',
    reportProgress?: boolean
  ): Observable<any> {
    if (!restaurantId || !restaurantBranchId) {
      throw new Error(
        'Required parameter missing when calling getInventoryMasters.'
      );
    }
    let queryParams = this.buildQueryParams({
      restaurantId,
      restaurantBranchId,
      pageNo,
      pageSize,
    });
    if (sortByParams) {
      sortByParams.forEach((param) => {
        queryParams = queryParams.append('sortByParams', <any>param);
      });
    }
    return this.request<SmartDineResponseListInventoryMasterModel>(
      'get',
      '/api/admin/inventorymasters',
      null,
      queryParams,
      observe,
      reportProgress
    );
  }

  public updateInventoryMaster(
    body: InventoryMasterModel,
    restaurantId: string,
    restaurantBranchId: string,
    inventoryMasterId: string,
    observe?: 'body' | 'response' | 'events',
    reportProgress?: boolean
  ): Observable<any> {
    if (!body || !restaurantId || !restaurantBranchId || !inventoryMasterId) {
      throw new Error(
        'Required parameter missing when calling updateInventoryMaster.'
      );
    }
    const queryParams = this.buildQueryParams({
      restaurantId,
      restaurantBranchId,
    });
    return this.request<SmartDineResponseInventoryMasterModel>(
      'put',
      `/api/admin/inventorymasters/${encodeURIComponent(
        String(inventoryMasterId)
      )}`,
      body,
      queryParams,
      observe,
      reportProgress
    );
  }
}
